import { thermostatProgrammingReducers } from './quickstart-thermostats.service';

export const QUICKSTART_THERMOSTAT_REDUCERS = {
  thermostatProgramming: thermostatProgrammingReducers
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-thermostats/quickstart-thermostats.store.ts